<style scoped>
    @import "./index.css";

    #tabBar {
        margin-bottom: 15px;
    }

    .select-type li {
        width: 145px;
        height: 145px;
    }

    #tfmack .ivu-spin-fix {
        background-color: rgba(255, 255, 255, .9) !important;
        z-index: 9999;
    }
</style>
<style>
    #sb-list .ivu-card-body {
        min-height: 180px;
    }
</style>
<template>
    <div v-if="this.$store.state.app.areaId>0" style="position: relative">

        <Spin v-if="!isShowData" size="large" fix>
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
            <div style="font-size: 12px">正在获取设备信息...</div>
        </Spin>

        <div id="tfmack">
            <Spin v-if="issbSwitch" size="large" fix></Spin>
        </div>

        <div id="layout-container-hui" class="tfmack">
            <!--tabBar-->
            <Row id="tabBar" type="flex" align="middle" justify="space-between">
                <Col>
                <Button style=" color: #28EDF8; background-color: #074A7F" type="text" @click="add" icon="md-add" >添加分类</Button>
                </Col>
            </Row>
            <!--tabBar end-->

            <!--列表-->
            <div v-if="isShowData">

                <div v-if="list.length <= 0"
                     style=" height:calc(100vh - 200px); font-size: 14px; color:#ddd; display: flex; align-items: center; justify-content: center">
                    <div style="line-height: 180%; text-align: center">
                        <Icon style="font-size: 50px; color:#ddd" type="ios-paper-plane-outline"/>
                        <br/>暂无数据
                    </div>
                </div>

                <Row v-else id="sb-list" class-name="tf-row" type="flex" align="top" justify="space-between">
                    <Col :md="12" :xs="24" v-for="(item,index) in list" :key="index">
                    <Card id="myCard" :bordered="false" :dis-hover="true">
                        <div class="myCard-head tf-center" slot="title">
                            <span class="myCard-title">{{item.catName}}</span>
                            <div>
                                <Button @click="addSb(index,item.catId)"
                                        style="position: relative; margin-left:5px; top:-1px" icon="md-add" title="添加设备"
                                        size="small" type="primary"></Button>
                                <Button @click="del(index,item.catId,item.catName)"
                                        style="position: relative; margin-left:5px; top:-1px" icon="md-trash"
                                        title="删除分类" size="small" type="error"></Button>
                                <Button @click="edit(index,item.catId,item.catName)"
                                        style="position: relative; margin-left:5px; top:-1px" icon="md-create"
                                        title="编辑名称" size="small" type="warning"></Button>
                                <span v-if="item.devices.length > 0">
                                        <Button v-if="item.catFlag == 2 && item.devices[0].factoryType != 2"
                                                @click="kaiqi(item.catId)"
                                                style="color: #fff; background-color:#28EDF8;position: relative; margin-left:5px; top:-1px" title="一键开启"
                                                size="small">一键开启</Button>
                                    </span>
                                <span v-if="item.devices.length > 0">
                                        <Button v-if="item.catFlag == 2 && item.devices[0].factoryType != 2"
                                                @click="guanbi(item.catId)"
                                                style="color: #fff; background-color:#28EDF8;position: relative; margin-left:5px; top:-1px" size="small"
                                                title="一键关闭">一键关闭</Button>
                                    </span>
                            </div>
                        </div>
                        <div class="myCard-con web-gailan overview">
                            <ul v-if="item.devices.length > 0" class="select-type">
                                <li @click="see(vo)" v-for="(vo,index2) in item.devices" :key="index2">
                                    <!--不是开关-->
                                    <div v-if="vo.switchNum == 0">
                                        <div :class="[vo.status ? '' : 'gray']">
                                            <img :src="imgSrc+vo.deviceImg" alt=""/>
                                            <p class="limit-1-line">{{vo.deviceName}}</p>
                                        </div>
                                    </div>
                                    <!--是开关-->
                                    <div v-else>
                                        <div :class="[vo.switchStatus && vo.status ? '' : 'gray']">
                                            <img :src="imgSrc+vo.deviceImg" alt=""/>
                                            <p class="limit-1-line">{{vo.deviceName}}</p>
                                        </div>
                                    </div>
                                    <!--故障-->
                                    <!--<span v-if="!vo.status">-->
                                            <!--<i class="animation"></i>&nbsp;故障-->
                                        <!--</span>-->
                                </li>
                            </ul>
                            <div v-else style="position: absolute; color: #ccc; top:40px; bottom: 0; left:0; right:0;"
                                 class="tf-flex tf-flex-middle tf-flex-center">暂无数据
                            </div>
                        </div>
                    </Card>
                    </Col>
                </Row>
            </div>

            <!--右侧弹出窗口-->
            <Drawer @on-close="onClose" :title="winTitle" :width="400" v-model="show">
                <dscjAdd ref="dscjAdd" v-if="type === 1" @refresh="getData" @close="onClose"></dscjAdd>
                <dscjShow v-if="type === 2" :sbinfo="sbInfo" @refresh="getData" @close="onClose"></dscjShow>
                <dscjMusic v-if="type === 3" :sbinfo="sbInfo" @refresh="getData" @close="onClose"></dscjMusic>
            </Drawer>

        </div>
    </div>
</template>

<script>

    import nopic from '@/assets/img/no_pic.png';
    import dscjAdd from "./add";
    import dscjShow from "./show";
    import dscjMusic from "./music";

    import dj from '@/assets/img/lx/dj.png';
    import sb from '@/assets/img/lx/sb.png';
    import dcf from '@/assets/img/lx/dcf.png';
    import wxkzg from '@/assets/img/lx/wxkzg.png';
    import znmb from '@/assets/img/lx/znmb.png';
    import cgq from '@/assets/img/lx/cgq.png';
    import sxt from '@/assets/img/lx/sxt.png';

    export default {
        name: "add",
        components: {
            dscjAdd,
            dscjShow,
            dscjMusic
        },
        data() {
            return {
                imgSrc: this.$func.imgSrc,

                sbInfo: '', //设备信息
                isShowData: false,

                //图片
                dj: dj,
                sb: sb,
                dcf: dcf,
                wxkzg: wxkzg,
                znmb: znmb,
                cgq: cgq,
                sxt: sxt,

                //设备开关
                issbSwitch: false,

                //图片
                nopic: nopic,

                //侧边弹出+步骤索引
                show: false,
                type: 1, //1添加 2详情 3音乐详情
                winTitle: "",

                list: [],
                oldData: '',
                //设备预警
                sbyjList: []
            };
        },
        computed: {
            //接收socket消息
            wsMessage() {
                return this.$store.state.app.wsMessage;
            },
            areaId(){
                return this.$store.state.app.areaId;
            },
        },
        watch: {
            //监控并且格式化socket消息
            wsMessage(r){
                this.getData();
            },
            areaId(){
                this.getData();
            },
            winTitle(val){
                //第一次绑定的时候执行监听函数
                immediate: true;
                this.winTitle = val;
            },
        },
        created(){
            const that = this;
            //延迟0.5秒，防止areaId未写入
            setTimeout(function () {
                that.getData();
            }, 500)

        },
        mounted(){
             // const that = this;
             // setInterval(function(){
             //     that.getData();
             // },3000)
        },

        methods: {
            //获取设备预警状态
            getDevideNotice(list){
                const that = this;
                let _list = list;
                if (_list.length === 0) {
                    that.isShowData = true;
                    return;
                }
                _list.map(function (vo, index) {
                    setTimeout(function () {
                        if (vo.devices.length > 0) {
                            vo.devices.map(function (vo2, index2) {
                                //添加分类
                                that.list[index].devices[index2].catName = vo.catName;
                                //设备默认不正常
                                that.list[index].devices[index2].status = false;
                                //设备默认关闭
                                that.list[index].devices[index2].switchStatus = false;

                                //判断厂商
                                if (vo2.factoryType == 1) //天正
                                {
                                    //判断设备是否开机
                                    that.$func.tz.getDevideInfo(vo2.deviceMac, function (res) {
                                        if (res && res.eqmsg) {

                                            //替换最新网关
                                            that.list[index].devices[index2].netMac = res.gmac;

                                            //接口通，设备正常
                                            that.list[index].devices[index2].status = true;

                                            //设备返回值
                                            that.list[index].devices[index2].eqmsg = res.eqmsg;

                                            //首先格式化消息
                                            if (res.eqmsg.split(',').length > 1) //多数据 可能存在 多路
                                            {
                                                //判断是否是控制器
                                                that.list[index].devices[index2].switch = [];
                                                let switchStatus = false;
                                                res.eqmsg.split(',').map(function (vv, ii) {
                                                    //是开关
                                                    if (that.$store.state.app.tz.offCode.indexOf(vv) > -1 || that.$store.state.app.tz.onCode.indexOf(vv) > -1) {
                                                        that.list[index].devices[index2].switchNum = res.eqmsg.split(',').length;
                                                        //判断开和关
                                                        if (that.$store.state.app.tz.offCode.indexOf(vv) > -1) {
                                                            that.list[index].devices[index2].switch[ii] = {
                                                                name: (ii + 1) + '路',
                                                                value: vv,
                                                                status: false
                                                            };
                                                        } else if (that.$store.state.app.tz.onCode.indexOf(vv) > -1) {
                                                            switchStatus = true;
                                                            that.list[index].devices[index2].switch[ii] = {
                                                                name: (ii + 1) + '路',
                                                                value: vv,
                                                                status: true
                                                            };
                                                        }
                                                        //不是开关
                                                    } else {
                                                        that.list[index].devices[index2].switchNum = 0;
                                                    }
                                                })
                                                that.list[index].devices[index2].switchStatus = switchStatus;

                                            } else //单数据
                                            {
                                                if (that.$store.state.app.tz.offCode.indexOf(res.eqmsg) > -1) {
                                                    that.list[index].devices[index2].switchNum = 1;
                                                    that.list[index].devices[index2].switchStatus = false;
                                                    that.list[index].devices[index2].switch = [
                                                        {
                                                            name: '1路',
                                                            value: res.eqmsg,
                                                            status: false
                                                        }
                                                    ];
                                                } else if (that.$store.state.app.tz.onCode.indexOf(res.eqmsg) > -1) {
                                                    that.list[index].devices[index2].switchNum = 1;
                                                    that.list[index].devices[index2].switchStatus = true;
                                                    that.list[index].devices[index2].switch = [
                                                        {
                                                            name: '1路',
                                                            value: res.eqmsg,
                                                            status: true
                                                        }
                                                    ];
                                                } else {
                                                    that.list[index].devices[index2].switchNum = 0;
                                                }
                                            }
                                        } else {
                                            that.list[index].devices[index2].switchStatus = false;
                                            that.list[index].devices[index2].status = false;
                                        }

                                        //判断设备是否异常
                                        // if(index == _list.length-1){
                                        that.$func.tz.getDevideNotice(function (r) {
                                            that.$func.uniqueArr('emac', r).map(function (vo3, index3) {
                                                if (vo3.emac == vo2.deviceMac) {
                                                    if (vo3.htype < 2) {
                                                        that.list[index].devices[index2].status = false;
                                                    } else {
                                                        that.list[index].devices[index2].status = true;
                                                    }
                                                }
                                                that.$forceUpdate();
                                            })
                                        })
                                        // }

                                    }, function () {
                                        that.list[index].devices[index2].switchStatus = false;
                                        that.list[index].devices[index2].status = false;
                                    })

                                } else if (vo2.factoryType == 2) //萤石
                                {
                                    //不是开关
                                    that.list[index].devices[index2].switchNum = 0;
                                    //判断接口是否故障
                                    that.$func.ys.getDevideInfo(vo2.deviceMac, function (res) {
                                        if (res.data.status) {
                                            that.list[index].devices[index2].switchStatus = true;
                                            that.list[index].devices[index2].status = true;
                                        } else {
                                            that.list[index].devices[index2].switchStatus = false;
                                            that.list[index].devices[index2].status = false;
                                        }
                                        that.$forceUpdate();
                                    }, function () {
                                        that.list[index].devices[index2].switchStatus = false;
                                        that.list[index].devices[index2].status = false;
                                        that.$forceUpdate();
                                    })
                                    //获取直播地址
                                    that.list[index].devices[index2].dinfo = {};
                                    that.$func.ys.getDevideAddress(vo2.deviceMac, function (res) {
                                        that.list[index].devices[index2].dinfo = res.data;
                                    })

                                } else if (vo2.factoryType == 3) //晶控
                                {
                                    console.log(vo2);
                                    var deviceMac='';
                                    var list='';
                                    if(vo2.isGroup==0){//单个设备
                                        deviceMac=vo2.deviceMac;
                                    }else {//组合设备,拿组合的第一个设备的状态来决定组合设备的状态
                                        var groupDevice=JSON.parse(vo2.groupDevice);
                                        deviceMac=groupDevice[0].deviceMac;
                                        list=groupDevice[0].wires.split(',')[0];//第一个设备第一路
                                    }
                                    //判断是否开启
                                    that.$func.ajax('sendCommand', {
                                        token: that.$func.getToken(),
                                        deviceCode: deviceMac,
                                        command: 'RELAY-STATE-x',
                                    }, function (r) {
                                        console.log('%%%%%%%%%%%%%%%%');
                                        console.log(r);
                                        if (!r.statusCode) {
                                            that.list[index].devices[index2].switchStatus = false;
                                            that.list[index].devices[index2].status = false;
                                            that.$func.msg(r.message, 'error');
                                        } else {
                                            if (r.type.status !== '0') {
                                                that.list[index].devices[index2].switchStatus = false;
                                                that.list[index].devices[index2].status = false;
                                            } else {
                                                that.list[index].devices[index2].status = true;
                                                //判断灯具和智能面板
                                                if (vo2.eid == 'dj') //灯具
                                                {
                                                    //调用查询接口判断位数
                                                    var str2 = that.$func.getJkSwitchOrder(r.type.result);
                                                    //判断开关
                                                    if (str2 === '0' || str2 === '0,0,0,0') {
                                                        that.list[index].devices[index2].switchNum = 1;
                                                        that.list[index].devices[index2].switchStatus = false;
                                                        that.list[index].devices[index2].switch = [
                                                            {
                                                                name: '1路',
                                                                value: r.type.result,
                                                                status: false
                                                            }
                                                        ];
                                                    } else {
                                                        that.list[index].devices[index2].switchNum = 1;
                                                        that.list[index].devices[index2].switchStatus = true;
                                                        that.list[index].devices[index2].switch = [
                                                            {
                                                                name: '1路',
                                                                value: r.type.result,
                                                                status: true
                                                            }
                                                        ];
                                                    }

                                                } else if (vo2.eid == 'znmb') //智能面板
                                                {
                                                    if(vo2.isGroup==0){//单个设备
                                                        //调用查询接口判断位数
                                                        var str3 = that.$func.getJkSwitchOrder(r.type.result);
                                                        //按钮名称
                                                        var remarkArr = vo2.remark.split('\r\n');
                                                        //判断设备路数
                                                        var lens = remarkArr.length;
                                                        //判断开关
                                                        if (str3 === '0' || str3 === '0,0,0,0') //全关
                                                        {
                                                            that.list[index].devices[index2].switchNum = lens;
                                                            that.list[index].devices[index2].switchStatus = false;
                                                            //反编译开关
                                                            var lensswitchs1 = [];
                                                            for (let ii = 0; ii < lens; ii++) {
                                                                lensswitchs1.push({
                                                                    name: remarkArr[ii],
                                                                    value: r.type.result,
                                                                    status: false
                                                                })
                                                            }
                                                            that.list[index].devices[index2].switch = lensswitchs1;

                                                        } else //部分关
                                                        {
                                                            //哪几路开启
                                                            var switchOn = that.$func.deTransformCode(lens, that.$func.getJkSwitchOrder(r.type.result));
                                                            that.list[index].devices[index2].switchNum = lens;
                                                            if (switchOn.length > 0) {
                                                                that.list[index].devices[index2].switchStatus = true;
                                                            } else {
                                                                that.list[index].devices[index2].switchStatus = false;
                                                            }
                                                            console.log(switchOn)
                                                            //反编译开关
                                                            var lensswitchs = [];
                                                            for (let ii = 0; ii < lens; ii++) {
                                                                lensswitchs.push({
                                                                    name: remarkArr[ii],
                                                                    value: r.type.result,
                                                                    status: switchOn.indexOf(ii + 1) === -1 ? false : true
                                                                })
                                                            }
                                                            that.list[index].devices[index2].switch = lensswitchs;
                                                        }
                                                    }else {//组合设备
                                                        //调用查询接口判断位数
                                                        var remarkArr = vo2.remark.split('\r\n');
                                                        //判断设备路数
                                                        var lens = remarkArr.length;
                                                        var switchOn = that.$func.deTransformCode(lens, that.$func.getJkSwitchOrder(r.type.result));
                                                        //判断开关
                                                        if ( switchOn.indexOf(Number(list)) != -1 ) {//第一个设备的第一路  开
                                                            that.list[index].devices[index2].switchNum = 1;
                                                            that.list[index].devices[index2].switchStatus = true;
                                                            that.list[index].devices[index2].switch = [
                                                                {
                                                                    name: '组合开关',
                                                                    value: r.type.result,
                                                                    status: true
                                                                }
                                                            ];
                                                        } else {//关
                                                            that.list[index].devices[index2].switchNum = 1;
                                                            that.list[index].devices[index2].switchStatus = false;
                                                            that.list[index].devices[index2].switch = [
                                                                {
                                                                    name: '组合开关',
                                                                    value: r.type.result,
                                                                    status: false
                                                                }
                                                            ];
                                                        }
                                                    }

                                                }
                                            }
                                            that.$forceUpdate();
                                        }
                                    }, function () {
                                        that.list[index].devices[index2].switchStatus = false;
                                        that.list[index].devices[index2].status = false;
                                        that.$forceUpdate();
                                    }, 'post', true, function () {
                                        that.list[index].devices[index2].switchStatus = false;
                                        that.list[index].devices[index2].status = false;
                                        that.$forceUpdate();
                                    })
                                }else if (vo2.factoryType == 4) //凯图
                                {
                                    //默认关
                                    that.list[index].devices[index2].switchStatus = false;
                                    that.$KtApi.getBrightness(that.$KtApi.getIdByEid(vo2.eid),{domainName:vo2.netMac,hostIp:vo2.deviceMac}, function (msg) {
                                        for(let ii=0 ; ii < msg.bright.length ; ii++){
                                            that.list[index].devices[index2].status = true;
                                            //有一路开则开
                                            if(msg.bright[ii].status){
                                                that.list[index].devices[index2].switchStatus = true;
                                                continue;
                                            }
                                        }
                                        that.$forceUpdate();
//                                    console.log('凯图查询更新：'+JSON.stringify(msg))
                                    }, function (err) {
                                        that.list[index].devices[index2].switchStatus = false;
                                        that.list[index].devices[index2].status = false;
                                        that.$forceUpdate();
                                    })
                                }else if (vo2.factoryType == 5) //精讯
                                {
                                    if(that.$func.isSensor(vo2.eid)){//传感器
                                        that.$func.jx.selSingleSensorData(vo2.deviceMac,vo2.eid,function (r) {
                                            that.list[index].devices[index2].switchStatus = true;
                                            that.list[index].devices[index2].status = true;
                                            //设备返回值
                                            that.list[index].devices[index2].eqmsg = r.eqmsg;
                                            setTimeout(function () {
                                                that.$forceUpdate();
                                            }, 1000)
                                        },function (err) {
                                            that.list[index].devices[index2].switchStatus = false;
                                            that.list[index].devices[index2].status = false;
                                            setTimeout(function () {
                                                that.$forceUpdate();
                                            }, 1000)
                                        });
                                    }else {//继电器
                                        var deviceNumber='';
                                        var list='';
                                        if(vo2.isGroup==0){//单个设备
                                            deviceNumber=vo2.deviceMac;
                                        }else {//组合设备,拿组合的第一个设备的状态来决定组合设备的状态
                                            var groupDevice=JSON.parse(vo2.groupDevice);
                                            deviceNumber=groupDevice[0].deviceMac;
                                            list=groupDevice[0].wires.split(',')[0];//第一个设备第一路
                                        }
                                        //判断是否开启
                                        that.$func.jx.getDeviceInfo(deviceNumber,vo2.eid, function (r) {
                                            if(vo2.isGroup==0){//单个设备
                                                //按钮名称
                                                var remarkArr = vo2.remark.split('\r\n');
                                                //判断设备
                                                var lens = remarkArr.length;
                                                //判断开关
                                                that.list[index].devices[index2].switchNum = lens;
                                                that.list[index].devices[index2].switchStatus = r.isOpen;
                                                that.list[index].devices[index2].status = !r.broken;
                                                //反编译开关
                                                var lensswitchs = [];
                                                for (let ii = 0; ii < lens; ii++) {
                                                    lensswitchs.push({
                                                        name: remarkArr[ii],
                                                        value: '',
                                                        status: r.stateArr[ii]
                                                    })
                                                }
                                                that.list[index].devices[index2].switch = lensswitchs;
                                            }else {//组合设备
                                                that.list[index].devices[index2].switchNum = 1;
                                                that.list[index].devices[index2].switchStatus = r.isOpen;
                                                that.list[index].devices[index2].status = !r.broken;
                                                //第一个设备的第一路是开则开
                                                that.list[index].devices[index2].switch = [
                                                    {
                                                        name: '组合开关',
                                                        value: '',
                                                        status: r.stateArr[list-1]
                                                    }
                                                ];
                                            }
                                            setTimeout(function () {
                                                that.$forceUpdate();
                                            }, 1000)
                                        }, function () {
                                            that.list[index].devices[index2].switchStatus = false;
                                            that.list[index].devices[index2].status = false;
                                            setTimeout(function () {
                                                that.$forceUpdate();
                                            }, 1000)
                                        })
                                    }
                                }else if (vo2.factoryType == 6) //芯蚁
                                {
                                    console.log(vo2);
                                    that.$func.ajax('getInfoCache', {
                                        token:that.$func.getToken(),
                                        deviceNo: vo2.deviceId
                                    }, function (r) {
                                        if (r.statusCode) {//成功
                                            that.list[index].devices[index2].switchStatus = r.type.info.isOpen==0? false:true;
                                            that.list[index].devices[index2].status = true;
                                            that.list[index].devices[index2].switch = [];
                                            if(that.$func.isRelay(vo2.eid) || vo2.eid.indexOf('valve') != -1) {//继电器、电磁阀
                                                if(vo2.isGroup==0){//单个设备
                                                    //按钮名称
                                                    var remarkArr = vo2.remark.split('\r\n');
                                                    //判断设备
                                                    var lens = remarkArr.length;
                                                    //判断开关
                                                    that.list[index].devices[index2].switchNum = lens;
                                                    //反编译开关
                                                    var lensswitchs = [];
                                                    if(vo2.eid.indexOf('relay-1') != -1){
                                                        console.log("电磁阀");
                                                        that.list[index].devices[index2].switch = [
                                                            {
                                                                name: '开关',
                                                                value: '',
                                                                status: r.type.info.isOpen==0? false:true
                                                            }
                                                        ];
                                                    }else{
                                                        for (let ii = 0; ii < lens; ii++) {
                                                            lensswitchs.push({
                                                                name: remarkArr[ii],
                                                                value: '',
                                                                status:  r.type.info.switchArr[ii]
                                                            })
                                                        }
                                                        that.list[index].devices[index2].switch = lensswitchs;
                                                    }
                                                }else {//组合设备
                                                    that.list[index].devices[index2].switchNum = 1;
                                                    that.list[index].devices[index2].switch = [
                                                        {
                                                            name: '组合开关',
                                                            value: '',
                                                            status: r.type.info.isOpen==0? false:true
                                                        }
                                                    ];
                                                }
                                            }else if(vo2.eid.indexOf('sensor') != -1) {//传感器
                                                var eqmsg=that.$func.sensorData(vo2.eid,6);
                                                eqmsg.map(function (vv, ii) {
                                                    eqmsg[ii].value=r.type.info.value[vv.index];
                                                });
                                                that.list[index].devices[index2].eqmsg = eqmsg;//数组
                                            }
                                        } else {//离线
                                            that.list[index].devices[index2].switchStatus = false;
                                            that.list[index].devices[index2].status = false;
                                        }
                                        setTimeout(function () {
                                            that.$forceUpdate();
                                        }, 1000)
                                    }, function () {
                                        that.list[index].devices[index2].switchStatus = false;
                                        that.list[index].devices[index2].status = false;
                                        setTimeout(function () {
                                            that.$forceUpdate();
                                        }, 1000)
                                    })
                                }

                            })


                            setTimeout(function () {
                                that.$forceUpdate();
                                that.isShowData = true;
                            }, 10000)
                        } else {
                            that.isShowData = true;
                        }
                    },500)

                })
            },

            //关闭侧滑
            onClose(){
                this.type = 0
                this.show = false;
            },
            //添加数据
            getData(){
                const that = this;
                that.$func.ajax('catList', {
                    catPosition: 3,
                    flag: 1,
                    token: that.$func.getToken(),
                    areaId:that.$store.state.app.areaId
                }, function (r) {
                    if (!r.statusCode) {
                        that.$func.msg(r.message, 'error');
                    } else {
                        that.list = r.type;
                        console.log('&&&&&&&&&&&&&&&&&&&&&&&&&&');
                        console.log(that.list);
                        that.getDevideNotice(r.type);
                    }
                })
            },

            //查看
            see(vo){
                const that = this;
                that.sbInfo = vo;
                if(vo.eid.indexOf('music')!=-1){
                    that.type = 3;
                    that.sbInfo.modeType=0;
                }else {
                    that.type = 2;
                }
//                that.winTitle = vo.deviceName + " - 设备详情";
                that.winTitle = vo.deviceName;
                that.show = true;
                console.log("即将进入");
                console.log(that.sbInfo);
            },
            //新增分类
            add() {
                const that = this;
                that.type = 1;
                that.winTitle = "添加分类";
                that.show = true;
            },
            //编辑分类
            edit(index, id, name) {
                const that = this;
                var newVal = '';
                that.$Modal.confirm({
                    title: '编辑分类',
                    render: (h) => {
                        return h('Input', {
                            props: {
                                value: name,
                                autofocus: true,
                                placeholder: '请输入分类名称',
                                maxlength: 10
                            },
                            on: {
                                input: (val) => {
                                    newVal = val
                                }
                            }
                        })
                    },
                    onOk: () => {
                        that.$func.ajax('customerCatSave', {
                            catId: id,
                            catSelfName: newVal || name,
                            token: that.$func.getToken()
                        }, function (r) {
                            if (!r.statusCode) {
                                that.$func.msg(r.message, 'error');
                            } else {
                                that.list[index].catName = newVal;
                                that.$Message.success('修改成功');
                            }
                        })
                    }
                })
            },
            //删除
            del(index, id, name) {
                const that = this;
                that.$Modal.confirm({
                    title: '确定删除分类吗？',
                    content: '分类删除后无法回撤，请您知晓！',
                    onOk: () => {
                        that.$func.ajax('customerCatDel', {
                            catId: id,
                            token: that.$func.getToken()
                        }, function (r) {
                            if (!r.statusCode) {
                                that.$func.msg(r.message, 'error');
                            } else {
                                that.list.splice(index, 1);
                                that.$func.msg('删除成功');
                            }
                        })
                    }
                })
            },
            //晶控灯具/智能面板一键开关设备
            jkDjOnChange(val, res)
            {
                const that = this;
                //判断开关
                if (val) //默认关闭，执行开启
                {
                    //判断是否是否开启
                    that.$func.ajax('sendCommand', {
                        token: that.$func.getToken(),
                        deviceCode: res.deviceMac,
                        command: 'RELAY-SET_ALL-x,255,255,255,255'
                    }, function (r) {
                        if (!r.statusCode) {
                            that.$func.msg(r.message, 'error');
                        } else {
                            if (r.type.status !== '0') {
                                that.$func.msg('操作失败，设备故障！', 'error')
                            }
                        }
                    })

                } else { //默认开启，执行关闭

                    //判断是否是否开启
                    that.$func.ajax('sendCommand', {
                        token: that.$func.getToken(),
                        deviceCode: res.deviceMac,
                        command: 'RELAY-SET_ALL-x,0,0,0,0'
                    }, function (r) {
                        if (!r.statusCode) {
                            that.$func.msg(r.message, 'error');
                        } else {
                            if (r.type.status !== '0') {
                                that.$func.msg('操作失败，设备故障！', 'error')
                            }
                        }
                    })
                }
            },
            //天正开关设备
            onTzChange(val, status, res)
            {
                const that = this;
                //判断开关
                let sbcode = '';
                if (status) {
                    sbcode = val.substr(0, val.length - 1) + '1';
                } else if (val.substr(val.length - 1, 1) == '1') {
                    sbcode = val.substr(0, val.length - 1) + '0';
                }
                //操作
                that.$func.tz.setDevideSwitch(
                    {
                        EMac: res.deviceMac,//设备 mac
                        GMac: res.netMac,//网关 mac
                        Instructions: '58',//控制指令
                        Msg: sbcode //发送消息指令（设备指令）
                    }, function (r) {

                    })
            },
            onKeyOnOff(catId, isOpen){
                var that = this;
                that.$func.ajax('onKeyOnOff',{
                    areaId :that.$store.state.app.areaId,
                    mobileId:that.$func.getToken(),
                    isOpen: isOpen,
                    catId: catId
                },function (r) {
                    if (!r.statusCode) {
                        that.$func.msg(r.message, 'error');
                    } else {
                        that.$Message.destroy();
                        if (r.type.status === '0') {
                            that.getInfo();
                            that.$emit("refresh");
                            //启用点击按钮
                            that.issbSwitch = false;
                        }else{
                            that.$func.msg('操作失败，设备故障！','error')
                        }
                    }
                })
            },

            //一键开启
            kaiqi(catId) {
                var that = this;
                that.$Modal.confirm({
                    title: '确定开启全部设备吗？',
                    content: '将会把该类目下的所有设备开启，故障设备除外，请您知晓！',
                    onOk: () => {
                        that.issbSwitch = true;
                        that.$Message.loading({
                            content: '操作中...',
                            duration: 0
                        });
                        that.onKeyOnOff(catId,true);
                        setTimeout(function () {
                            that.$Message.destroy();
                            that.getData();
                            that.issbSwitch = false;
                        }, 20000)
                    }
                })
            },
            //一键关闭
            guanbi(catId) {
                var that = this;
                that.$Modal.confirm({
                    title: '确定关闭全部设备吗？',
                    content: '将会把该类目下的所有设备关闭，故障设备除外，请您知晓！',
                    onOk: () => {
                        that.issbSwitch = true;
                        that.$Message.loading({
                            content: '操作中...',
                            duration: 0
                        });
                        that.onKeyOnOff(catId,false);
                        setTimeout(function () {
                            that.$Message.destroy();
                            that.getData();
                            that.issbSwitch = false;
                        }, 20000)
                    }
                })
            },

            //添加设备
            addSb(index, id) {
                const that = this;
                var newVal = '';
                var newVal2 = '';
                that.$Modal.confirm({
                    title: '添加设备',
                    render: (h) => {
                        return h('div', [
                            h('div', [
                                h('div', [
                                    h('label', '设备编号：', {
                                        style: {
                                            width: '20%',
                                            marginRight: '.3rem'
                                        },
                                    }),
                                    h('Input', {
                                        style: {
                                            width: '80%'
                                        },
                                        props: {
                                            value: '',
                                            autofocus: true,
                                            placeholder: '请输入设备编号',
                                            maxlength: 13
                                        },
                                        on: {
                                            input: (val) => {
                                                newVal = val;
                                            }
                                        }
                                    })
                                ]),
                                h('div', {
                                    style: {
                                        marginTop: '.2rem'
                                    },
                                }, [
                                    h('label', '设备名称：', {
                                        style: {
                                            width: '20%',
                                            marginRight: '.3rem'
                                        },
                                    }),
                                    h('Input', {
                                        style: {
                                            width: '80%'
                                        },
                                        props: {
                                            value: '',
                                            autofocus: true,
                                            placeholder: '请输入设备名称',
                                            maxlength: 10
                                        },
                                        on: {
                                            input: (val) => {
                                                newVal2 = val;
                                            }
                                        }
                                    })
                                ]),
                            ])
                        ])
                    },
                    onOk: () => {
                        if (newVal == '') {
                            this.$Message.error('设备编号不能为空');
                            return
                        }
                        if (isNaN(newVal)) {
                            this.$Message.error('设备编号必须为13位数字');
                            return
                        }
                        if (newVal2 == '') {
                            this.$Message.error('设备名称不能为空');
                            return
                        }
                        that.$func.ajax('custDeviceSave', {
                            catId: id,
                            deviceNo: newVal,
                            deviceName: newVal2,
                            token: that.$func.getToken(),
                            areaId:that.$store.state.app.areaId
                        }, function (r) {
                            if (!r.statusCode) {
                                that.$func.msg(r.message, 'error');
                            } else {
                                that.$Message.success('添加成功');
                                that.getData();
                            }
                        })
                    }
                })
            },

//                        var regu =/^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
//                        var re = new RegExp(regu);
//                        if(!re.test(that.custDomain.hostIp)) {
//                            this.$Message.error('主机IP格式不正确');
//                            return
//                        }

        }
    };
</script>

